/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_Path_PendingInputs */

const cs_blog_website_path_pending = /** @type {(inputs: Blog_Website_Path_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/blog/…`)
};

const en_blog_website_path_pending = /** @type {(inputs: Blog_Website_Path_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/blog/…`)
};

/**
* | output |
* | --- |
* | "/blog/…" |
*
* @param {Blog_Website_Path_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_path_pending = /** @type {((inputs?: Blog_Website_Path_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_Path_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_path_pending(inputs)
	return cs_blog_website_path_pending(inputs)
});